import { render, staticRenderFns } from "./WidgetListItem.vue?vue&type=template&id=40c6a1a7&scoped=true"
import script from "./WidgetListItem.vue?vue&type=script&lang=js"
export * from "./WidgetListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c6a1a7",
  null
  
)

export default component.exports